import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  Card,
  Grid,
  InputLabel,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SnackbarComponent from "../../components/snackbar/index.tsx";
import { mobileOtpThunk, verifyOtpThunk } from "./reducer/thunk.js";
import Methods from "../../utility/Methods.js";
import Colors from "../../utility/Colors.js";
import OtpVerification from "../../components/otpVerification/otpVerification.js";
import { useNavigate } from "react-router-dom";
import { getSession, setLoginDetails } from "../../utility/SessionManager.js";
import constants from "../../common/constants.js";
import { Box } from "@mui/system";
import BackdropComponent from "../../components/backdrop/index.tsx";
import { resetMobileOtp, resetVerifyOtp } from "./reducer/slice.js";

const AadhaarLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showOTP, setShowOTP] = useState(false);
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [OTP, setOTP] = useState("");
  const [txnId, setTxnId] = useState("");
  const [message, setMessage] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    severity: "",
    message: "",
  });

  const mobileOtp = useSelector((state) => state.login.mobileOtp);
  const {
    status: mobileOtpStatus,
    data: mobileOtpData,
    error: mobileOtpError,
  } = mobileOtp;
  const verifyOtp = useSelector((state) => state.login.verifyOtp);
  const {
    status: verifyOtpStatus,
    data: verifyOtpData,
    error: verifyOtpError,
  } = verifyOtp;
  const { loading } = useSelector((state) => state.auth);
  const [checked, setChecked] = React.useState(false);

  const handleCheckBoxChange = (event) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    if (mobileOtpStatus === "succeeded") {
      console.log("enc res", mobileOtpData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(mobileOtpData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(mobileOtpData?.data));
      console.log("test ", decData.response);
      let finalData = decData.response;
      setTxnId(finalData?.txnId);
      setMessage(finalData?.message);
      setShowOTP(true);
      handleShowSnackbar("success", "OTP sent successfully!");
    } else if (mobileOtpStatus === "failed") {
      let decData = JSON.parse(Methods.decryptData(mobileOtpError));
      console.log("mobile status data", decData);
      let finalData = decData?.error?.errorMessage;
      handleShowSnackbar("error", finalData);
    }
  }, [mobileOtpStatus]);

  useEffect(() => {
    if (verifyOtpStatus === "succeeded") {
      console.log("enc res", verifyOtpData);
      console.log(
        "response",
        JSON.parse(Methods.decryptData(verifyOtpData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(verifyOtpData?.data));
      console.log("verifyOtp data", decData.response);
      let finalData = decData.response;
      if (finalData?.authResult === "failed") {
        handleShowSnackbar("error", finalData?.message);
      } else if (finalData?.authResult === "success") {
        setLoginDetails(finalData);
        navigate(constants.PATH_DASHBOARD);
        navigate("/dashboard");
        handleShowSnackbar("success", "OTP verified successfully!");
      }
    } else if (verifyOtpStatus === "failed") {
      let decData = JSON.parse(Methods.decryptData(verifyOtpError));
      // console.log("verifyOtp data", decData);
      let finalData = decData?.error?.errorMessage;
      handleShowSnackbar("error", finalData);
    }
  }, [verifyOtpStatus]);

  useEffect(() => {
    if (getSession(window, constants.SS_KEY_GROUP_ACCESS_TOKEN)) {
      navigate(constants.PATH_DASHBOARD);
    }
  }, [navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
    //!to reset next button redirection functionality
    return () => {
      dispatch(resetVerifyOtp());
      dispatch(resetMobileOtp());
    };
  }, []);

  const handleShowSnackbar = (severity, message) => {
    setSnackbarOpen({
      open: true,
      severity,
      message,
    });
  };

  const handleSnackClose = () => {
    setSnackbarOpen({
      open: false,
      severity: "",
      message: "",
    });
  };

  const validationSchema = Yup.object({
    aadhaarNumber: Yup.string()
      .matches(/^\d{12}$/, "Enter a valid 12-digit Aadhaar number")
      .required("Aadhaar number is required"),
  });

  const handleSubmitData = async (data) => {
    setAadhaarNumber(data?.aadhaarNumber);
    const reqObj = {
      loginId: data?.aadhaarNumber || "",
      loginHint: "aadhaar",
      scope: "aadhaar-verify",
      txnId: "",
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    console.log("decrypted object", Methods.decryptObject(finalReqObj));

    dispatch(mobileOtpThunk(finalReqObj));
  };

  const handleVerifyOtp = (otp) => {
    setOTP(otp);
    let reqObj = {
      txnId: txnId,
      otp: otp,
      scope: "aadhaar-verify",
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    console.log(
      "decrypted object verify otp",
      Methods.decryptObject(finalReqObj)
    );
    dispatch(verifyOtpThunk(finalReqObj));
  };

  const handleResendOtp = () => {
    const reqObj = {
      loginId: aadhaarNumber,
      loginHint: "aadhaar",
      txnId: txnId,
      scope: "aadhaar-verify",
    };
    let finalReqObj = Methods.encryptObject(reqObj);
    dispatch(mobileOtpThunk(finalReqObj));
  };

  return (
    <div style={{ width: "100%" }}>
      <Card
        sx={{
          width: "100%",
          borderRadius: "10px",
          p: 2,
          boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
          "&:hover": {
            boxShadow: "#008080 0px 2px 5px",
          },
        }}
      >
        {mobileOtpStatus === "pending" && <BackdropComponent />}
        {verifyOtpStatus === "pending" && <BackdropComponent />}

        {!showOTP ? (
          <Formik
            initialValues={{ aadhaarNumber: "" }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              handleSubmitData(values);
            }}
          >
            {(props) => (
              <Form>
                <Grid container spacing={4} sx={{ p: 1 }}>
                  {[
                    {
                      name: "aadhaarNumber",
                      label: "AADHAAR Number",
                      type: "input",
                      required: true,
                    },
                  ].map((field) => (
                    <>
                      {field?.type === "input" ? (
                        <Grid item size={{ xs: 12, md: 4 }} key={field.name}>
                          <Field name={field.name}>
                            {({ field: formikField, meta }) => (
                              <>
                                <InputLabel
                                  htmlFor={field.label}
                                  sx={{ mb: 2 }}
                                >
                                  Enter AADHAAR Number
                                </InputLabel>
                                <TextField
                                  {...formikField}
                                  variant="outlined"
                                  size="medium"
                                  label={field.label}
                                  required={field?.required}
                                  type={
                                    field.type === "checkbox"
                                      ? "checkbox"
                                      : "text"
                                  }
                                  autoFocus={true}
                                  fullWidth
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton edge="end">
                                          <CheckCircleIcon
                                            color={
                                              meta.value && !meta.error
                                                ? "success"
                                                : "disabled"
                                            }
                                          />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                  error={meta.touched && Boolean(meta.error)}
                                  helperText={meta.touched && meta.error}
                                />
                              </>
                            )}
                          </Field>
                        </Grid>
                      ) : // : field?.type === "checkbox" ? (
                      //   <Grid item xs={12} md={12}>
                      //     <Field name={field.name}>
                      //       {({ field, meta }) => (
                      //         <FormControlLabel
                      //           control={
                      //             <Checkbox
                      //               {...field}
                      //               required
                      //               // checked={props.values.consent}
                      //               // onChange={(value) =>
                      //               //   props.setFieldValue(field.name, value)
                      //               // }
                      //               color="primary"
                      //             />
                      //           }
                      //           label={
                      //             <Typography variant="body2">
                      //               I, hereby declare that I am voluntarily
                      //               sharing my Aadhaar number and demographic
                      //               information issued by UIDAI, with National
                      //               Health Authority (NHA) for the sole purpose
                      //               of creation of ABHA number. I understand
                      //               that my ABHA number can be used and shared
                      //               for purposes as may be notified by ABDM from
                      //               time to time including provision of
                      //               healthcare services. Further, I am aware
                      //               that my personal identifiable information
                      //               (Name, Address, Age, Date of Birth, Gender
                      //               and Photograph) may be made available to the
                      //               entities working in the National Digital
                      //               Health Ecosystem (NDHE) which inter alia
                      //               includes stakeholders and entities such as
                      //               healthcare professionals (e.g. doctors),
                      //               facilities (e.g. hospitals, laboratories)
                      //               and data fiduciaries (e.g. health
                      //               programmes), which are registered with or
                      //               linked to the Ayushman Bharat Digital
                      //               Mission (ABDM), and various processes there
                      //               under. I authorize NHA to use my Aadhaar
                      //               number for performing Aadhaar based
                      //               authentication with UIDAI as per the
                      //               provisions of the Aadhaar (Targeted Delivery
                      //               of Financial and other Subsidies, Benefits
                      //               and Services) Act, 2016 for the aforesaid
                      //               purpose. I understand that UIDAI will share
                      //               my e-KYC details, or response of “Yes” with
                      //               NHA upon successful authentication. I have
                      //               been duly informed about the option of using
                      //               other IDs apart from Aadhaar; however, I
                      //               consciously choose to use Aadhaar number for
                      //               the purpose of availing benefits across the
                      //               NDHE. I am aware that my personal
                      //               identifiable information excluding Aadhaar
                      //               number / VID number can be used and shared
                      //               for purposes as mentioned above. I reserve
                      //               the right to revoke the given consent at any
                      //               point of time as per provisions of Aadhaar
                      //               Act and Regulations.
                      //             </Typography>
                      //           }
                      //         />
                      //       )}
                      //     </Field>
                      //   </Grid>
                      // )
                      null}
                    </>
                  ))}
                  <Box className="cc_tc_wrapper_box">
                    <Box className="cc_tc_box">
                      <Typography className="cc_tc_title">
                        Terms and Conditions
                      </Typography>
                      <Typography>
                        I, hereby declare that I am voluntarily sharing my
                        Aadhaar number and demographic information issued by
                        UIDAI, with National Health Authority (NHA) for the sole
                        purpose of creation of ABHA number. I understand that my
                        ABHA number can be used and shared for purposes as may
                        be notified by ABDM from time to time including
                        provision of healthcare services. Further, I am aware
                        that my personal identifiable information (Name,
                        Address, Age, Date of Birth, Gender and Photograph) may
                        be made available to the entities working in the
                        National Digital Health Ecosystem (NDHE) which inter
                        alia includes stakeholders and entities such as
                        healthcare professionals (e.g. doctors), facilities
                        (e.g. hospitals, laboratories) and data fiduciaries
                        (e.g. health programmes), which are registered with or
                        linked to the Ayushman Bharat Digital Mission (ABDM),
                        and various processes there under. I authorize NHA to
                        use my Aadhaar number for performing Aadhaar based
                        authentication with UIDAI as per the provisions of the
                        Aadhaar (Targeted Delivery of Financial and other
                        Subsidies, Benefits and Services) Act, 2016 for the
                        aforesaid purpose. I understand that UIDAI will share my
                        e-KYC details, or response of “Yes” with NHA upon
                        successful authentication. I have been duly informed
                        about the option of using other IDs apart from Aadhaar;
                        however, I consciously choose to use Aadhaar number for
                        the purpose of availing benefits across the NDHE. I am
                        aware that my personal identifiable information
                        excluding Aadhaar number / VID number can be used and
                        shared for purposes as mentioned above. I reserve the
                        right to revoke the given consent at any point of time
                        as per provisions of Aadhaar Act and Regulations.
                      </Typography>
                    </Box>
                    <Box className="cc_tc_ch_box">
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            checked={checked}
                            onChange={handleCheckBoxChange}
                          />
                        }
                        label="I agree"
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  sx={{ p: 1 }}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Button
                    sx={{
                      cursor: "pointer",
                      background:
                        !props.isValid && !props.dirty
                          ? "#b3b3b3"
                          : "rgb(245, 132, 31)",
                      color:
                        !props.isValid && !props.dirty
                          ? "#b3b3b3"
                          : Colors.WHITE,
                      px: 6,
                      my: 5,
                      borderRadius: "5px",
                      "&:hover": { opacity: 0.9 },
                    }}
                    type="submit"
                    disabled={!(props.isValid && props.dirty) || !checked}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Next"
                    )}
                  </Button>
                </Grid>
              </Form>
            )}
          </Formik>
        ) : (
          <OtpVerification
            onVerify={handleVerifyOtp}
            onResend={handleResendOtp}
            message={message}
          />
        )}

        <SnackbarComponent
          message={snackbarOpen?.message}
          isOpen={snackbarOpen?.open}
          purpose={snackbarOpen?.severity}
          handleClick={handleSnackClose}
        />
      </Card>
    </div>
  );
};

export default AadhaarLogin;
